import MenuItem from "@mui/material/MenuItem";
import MuiSelect from "@mui/material/Select";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import { getColumnLetter } from "src/helpers/flashcards/csvImport";

import type { ImportFormValues } from "./types";

type ColumnField =
	| "frontColumn"
	| "backColumn"
	| "deckNameColumn"
	| "deckDescriptionColumn";

interface ColumnMappingProps {
	columns: string[];
	// Tryb wielu zestawów — pokazuje kolumny z nazwą i opisem zestawu.
	multiDeck: boolean;
}

export const ColumnMapping = ({ columns, multiDeck }: ColumnMappingProps) => {
	const { t } = useTranslation();
	const { values, setFieldValue } = useFormikContext<ImportFormValues>();

	const columnLabel = (col: string, i: number) =>
		values.hasHeader ? `${getColumnLetter(i)} · ${col}` : col;

	const renderSelect = (
		field: ColumnField,
		label: string,
		optional = false,
	) => (
		<label className="flex flex-col gap-8">
			<span className="label-caps">
				{label}
				{optional && (
					<span className="font-light text-none">
						{` · ${t("csvImport.optional", "opcjonalnie")}`}
					</span>
				)}
			</span>
			<MuiSelect
				className="select--grey"
				value={values[field]}
				onChange={(e) => setFieldValue(field, Number(e.target.value))}
				data-test-id={`import-csv-${field}-select`}
			>
				{columns.map((col, i) => (
					<MenuItem key={`${col}-${i}`} value={i}>
						{columnLabel(col, i)}
					</MenuItem>
				))}
				{optional && (
					<MenuItem value={-1}>{t("csvImport.skip", "(pomiń)")}</MenuItem>
				)}
			</MuiSelect>
		</label>
	);

	return (
		<div className="flex flex-col gap-16">
			<div className="grid grid-cols-2 gap-12">
				{renderSelect("frontColumn", t("csvImport.front", "Przód fiszki"))}
				{renderSelect("backColumn", t("csvImport.back", "Tył fiszki"))}
				{multiDeck &&
					renderSelect(
						"deckNameColumn",
						t("csvImport.deckName", "Nazwa zestawu"),
						true,
					)}
				{multiDeck &&
					renderSelect(
						"deckDescriptionColumn",
						t("csvImport.deckDescription", "Opis zestawu"),
						true,
					)}
			</div>
		</div>
	);
};
